// extracted by mini-css-extract-plugin
export default {"tabWrapper":"Navbar_tabWrapper__7EDCr"};